import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { Checkbox, Form, Upload, Image, Input, Tabs } from 'antd';
import LoadableButton from "../../../../../components/buttons/LoadableButton.jsx";
import { DepositAmountApi, getBankDataApi } from '../../../../../api/request/wallet/cashdeposit.js';
import UploadDoc from '../../../../../assets/UploadDoc.jsx';

const CashDepositMobile = ({ amount, resetAll, loginTerminalId }) => {
    const [form] = Form.useForm();
    const { userDetails } = useSelector(state => state.user);
    const [isLoading, setIsLoading] = useState(false);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [previewImage, setPreviewImage] = useState('');
    const [bankData, setBankData] = useState([])
    const [selectedBank, setSelectedBank] = useState(0)
    const [signatureFileList, setSignatureFileList] = useState([]);

    const getBase64 = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });

    const extractOriginFileObjs = (fileArray) => {
        return fileArray ? fileArray.map((file) => file.originFileObj) : [];
    };

    const handleSubmit = async (values) => {
        setIsLoading(true);
        try {
            const UploadDocument = extractOriginFileObjs(values?.UploadDocument);

            let formData = new FormData();
            formData.append("UserId", userDetails?.id);
            formData.append("ReferenceId", values?.ReferenceId);
            formData.append("Comment", values?.Comment || "");
            formData.append("Amount", Number(amount).toFixed(2));
            formData.append("DepositType", 3);
            formData.append("LoginTerminalId", loginTerminalId === 'wallet' ? 0 : loginTerminalId);
            UploadDocument.forEach((file) => formData.append("PaymentProof", file));

            let apiHeaders = { headers: { Accept: "application/json", "Content-Type": "multipart/form-data" } };

            const { data } = await DepositAmountApi(formData, apiHeaders);
            if (data?.success) {
                toast.success(data?.message);
                setSignatureFileList([]);
                form.resetFields();
                resetAll();
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Deposit failed.');
        } finally {
            setIsLoading(false);
        }
    }

    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
    };

    const handleSignatureChange = ({ fileList: newSignatureList }) => {
        setSignatureFileList(newSignatureList);
        form.setFieldsValue({ UploadDocument: newSignatureList });
    };

    const UploadButton = (
        <button type="button">
            <div className='flex items-center justify-center gap-2 border rounded-md py-1.5 px-4 text-lg text-gray-500 font-medium'>
                <img src="/assets/icons/Upload_Document_icon.svg" alt="icon" className='h-5' />
                <span>Click to Upload</span>
            </div>
        </button>
    );

    const getBankDetails = async () => {
        try {
            const { data } = await getBankDataApi()
            setBankData(data?.data || []);
        } catch (err) { }
    }

    useEffect(() => {
        getBankDetails()
    }, [])


    return (
        <div>
            <Form form={form} layout="vertical" className='space-y-5 mb-6' onFinish={handleSubmit}>
                {/* Bank Details Section */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
                    <h3 className="text-lg font-semibold text-blue-600 pb-2 mb-4 border-b border-gray-200">Bank Details</h3>
                    <Tabs
                        activeKey={selectedBank.toString()}
                        onChange={(key) => setSelectedBank(Number(key))}
                        items={bankData.map((bank, index) => ({
                            key: index.toString(),
                            label: bank.bankName,
                            children: (
                                <div className="grid grid-cols-2 gap-6">
                                    {/* Left Column */}
                                    <div className="space-y-4">
                                        {/* Bank Name */}
                                        <div>
                                            <label className="block text-sm font-bold text-gray-700 mb-2">
                                                Bank Name
                                            </label>
                                            <p className="text-sm text-[#90A1B9]">{bank.bankName}</p>
                                        </div>

                                        {/* Account Number */}
                                        <div>
                                            <label className="block text-sm font-bold text-gray-700 mb-2">
                                                Ac Number
                                            </label>
                                            <p className="text-sm text-[#90A1B9]">{bank.accountNumber}</p>
                                        </div>

                                        {/* Branch */}
                                        <div>
                                            <label className="block text-sm font-bold text-gray-700 mb-2">
                                                Swift Code:
                                            </label>
                                            <p className="text-sm text-[#90A1B9]">{bank.swiftCode}</p>
                                        </div>
                                    </div>

                                    {/* Right Column */}
                                    <div className="space-y-4">
                                        {/* Holder Name */}
                                        <div>
                                            <label className="block text-sm font-bold text-gray-700 mb-2">
                                                Holder Name
                                            </label>
                                            <p className="text-sm text-[#90A1B9]">{bank.accountHolderName}</p>
                                        </div>

                                        {/* IBAN */}
                                        <div>
                                            <label className="block text-sm font-bold text-gray-700 mb-2">
                                                IBAN
                                            </label>
                                            <p className="text-sm text-[#90A1B9] break-all">{bank.ifscCode}</p>
                                        </div>
                                    </div>
                                </div>
                            ),
                        }))}
                    />
                </div>

                {/* Document Upload Section */}
                <div className="mb-6 space-y-5">
                    <Form.Item
                        name='ReferenceId'
                        label={<span className="text-lg text-gray-500 font-medium">Trasaction ID</span>}
                        rules={[{ required: true, message: 'Please enter trasaction id.' }]}
                    >
                        <Input placeholder="Trasaction ID" size='large' />
                    </Form.Item>

                    <Form.Item
                        name='Comment'
                        label={<span className="text-lg text-gray-500 font-medium">Comment</span>}
                    >
                        <Input placeholder="Comment" size='large' />
                    </Form.Item>
                    <Form.Item
                        name="UploadDocument"
                        rules={[{ required: true, message: 'Please upload at least one document!' }]}
                        className="mb-0 w-full custom-form-item"
                    >
                        <Upload.Dragger
                            name="files"
                            multiple
                            maxCount={2}
                            listType="picture"
                            accept=".pdf,.jpg,.jpeg,.png"
                            fileList={signatureFileList}
                            onChange={handleSignatureChange}
                            beforeUpload={(file) => {
                                if (signatureFileList.length >= 2) {
                                    setMessage("You can only upload up to 2 files.");
                                    return Upload.LIST_IGNORE; // ❌ Block upload
                                }
                                return false; // Prevent auto upload
                            }}
                            onPreview={handlePreview}
                            className="upload-dragger-custom w-full"
                            style={{
                                borderRadius: '16px',
                                border: '2px dashed #d1d5db',
                                backgroundColor: '#f9fafb'
                            }}
                        >
                            <div className="p-6 text-center">
                                {/* Upload Icon */}
                                <div className="flex justify-center mb-4">
                                    <div className="w-12 h-12 bg-blue-500 rounded-2xl flex items-center justify-center">
                                        <UploadDoc color="white" />
                                    </div>
                                </div>

                                {/* Upload Text */}
                                <h3 className="text-lg font-medium text-gray-700 mb-2">
                                    Upload your Document
                                </h3>

                                <p className="text-sm text-gray-500">
                                    Click or drag files to upload
                                </p>

                                {/* <p className="text-xs text-gray-400 mt-2">
                                Supports: PDF, JPG, PNG files
                            </p> */}
                            </div>
                        </Upload.Dragger>
                    </Form.Item>
                    {message && (
                        <p className="text-red-500 text-sm mt-2">
                            {message}
                        </p>
                    )}
                </div>

                {/* Image Preview Modal */}
                {
                    previewImage && (
                        <Image
                            wrapperStyle={{ display: 'none' }}
                            preview={{
                                visible: previewOpen,
                                onVisibleChange: (visible) => setPreviewOpen(visible),
                                afterOpenChange: (visible) => !visible && setPreviewImage(''),
                            }}
                            src={previewImage}
                        />
                    )
                }

                <div>
                    <Form.Item
                        name='conditions'
                        valuePropName="checked"
                        rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms and conditions.')) }]}
                    >
                        <Checkbox className='mt-4'>
                            Yes, I agreed to the <Link to={'/terms_&_conditions'} className='primary hover:underline duration-300'>Terms and conditions</Link>
                        </Checkbox>
                    </Form.Item>
                </div>

                <LoadableButton
                    className='bg-primary-mobile text-sm text-white font-semibold rounded-lg px-12 py-4 mt-4 w-full uppercase themeHover duration-500'
                    type="Submit"
                    lable='Deposit'
                    isLoading={isLoading}
                    loadingLable='Adding request...'
                />
            </Form>
        </div >
    )
}

export default CashDepositMobile
